import { useRef } from "react";

import { ShoppingCart } from "./ShoppingCart";

export const useShoppingCar = () => {
  const shoppingCarRef = useRef(
    new ShoppingCart({
      verifyAlreadyAdded: (addedItem: any, newItem: any) => {
        return addedItem.id === newItem.id;
      },
      findItemById: (addedItem: any, id: any) => {
        return addedItem.id === id;
      },
    })
  );

  return shoppingCarRef.current;
};
